import React from 'react';

import {EVENT_ID, dispatch} from '../../../../containers/event_manager';

export const ZenModeButton = (): React.ReactNode => {
	return <button onClick={() => dispatch(EVENT_ID.ZEN_MODE_TOGGLED)}>ZEN</button>;
};
